import { env } from "configs/EnvironmentConfig";
const {VLM_UI_URL} = env


export const handleAuthMessage = (event) => {
    const allowedOrigins = [VLM_UI_URL];
    console.log("event.origin",event.origin)
    if (!allowedOrigins.includes(event.origin)) {
        // console.warn(allowedOrigins," tried to access it");
      return;
    }
  
    if (event.data && event.data.accessToken) {
    //   console.log('Received auth data:', event.data);
  
      localStorage.setItem('auth_token', event.data.accessToken);
      localStorage.setItem('refresh_token', event.data.refreshToken);
      localStorage.setItem('user_email', event.data.email);
      localStorage.setItem('username', event.data.username);
      localStorage.setItem('auth_expires_in', event.data.tokenExpiry);
  
      if (event.source) {
        event.source.postMessage({ status: 'auth_received' }, event.origin);
      }
    }
  };